import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import Dashboard from '../views/Dashboard';
import ErrorBoundary from '../utils/errorBoundary';
import CacheInitializing from './CacheInitializing';

const AppContent = () => {
  const { isInitialized, isInitializing } = useSelector(state => state.cache);
  const { token } = useSelector(state => state.auth);

  if (token && !isInitialized && isInitializing) {
    return <CacheInitializing />;
  }

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Dashboard />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default AppContent;
